<template>
  <router-link class="no-underline" :to="permalink">
    <card has-outline :class="{disabled: !active}">
      <template v-slot:title>{{code}}</template>
      <template v-slot:badge>
        <span v-if="active">
          {{paymentCount}}
          <span v-if="limit"> / {{limit}}</span>
        </span>
        <span v-else>Expired</span>
      </template>
      <template>
        {{ label }} off
        <span v-if="endDate">
          until <date-string :timestamp="endDate" />
        </span>
      </template>
    </card>
  </router-link>
</template>

<script>
import Card from '@/components/Card.vue';
import DateString from '@/components/DateString.vue';

export default {
  name: 'DiscountPreview',
  components: { Card, DateString },
  props: {
    id: String,
    active: Boolean,
    code: String,
    currency: String,
    type: String,
    value: Number,
    limit: Number,
    endDate: Object,
    label: String,
    isExpired: Boolean,
    payments: Array,
  },
  computed: {
    paymentCount() {
      return this.payments ? this.payments.length : 0;
    },
    permalink() {
      return {
        name: 'EditDiscount',
        params: {
          id: this.id,
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.disabled {
  opacity: 0.6;
}
</style>
